import React, { useState } from 'react';

import { Stack, Flex, useMantineTheme } from '@mantine/core';
import { useDebouncedValue, useMediaQuery, useDisclosure } from '@mantine/hooks';
import ShoppingCart from 'components/ShoppingCart';
import { useAuth } from 'context/auth-context';
import { ProductRetrieve } from 'types';

import DrawerFeesAndMiscProductsForm from './components/DrawerFeesAndMiscProductsForm';
import FeesAndMiscProductsPageHeader from './components/FeesAndMiscProductsPageHeader';
import FeesAndMiscProductsTable from './components/FeesAndMiscProductsTable';

const FeesAndMiscProducts = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();

  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.lg}`, false);

  const [search, setSearch] = useState<string>('');
  const [orderByFavorites, setOrderByFavorites] = useState<boolean>(true);
  const [debouncedSearch] = useDebouncedValue<string>(search, 250);

  const [isFeeAndMiscDrawerOpened, { toggle: toggleDrawer }] = useDisclosure(false);
  const [productId, setProductId] = useState<string>('');

  const [cartItems, setCartItems] = useState<ProductRetrieve[]>([]);
  const [isShoppingCartOpened, { toggle: handleShoppingCartToggle }] = useDisclosure(isDesktop);

  const productMutatePerm = hasPerm('ProductMutate');
  const invoiceCreatePerm = hasPerm('InvoiceCreate');

  const handleCloseDrawer = (): void => {
    setProductId('');
    toggleDrawer();
  };

  return (
    <>
      <Flex sx={{ width: '100%', height: '100%' }}>
        <Stack
          spacing={0}
          sx={{
            width: isDesktop ? '50%' : '100%',
            height: '100%',
            display: !isShoppingCartOpened || isDesktop ? undefined : 'none',
          }}
        >
          <FeesAndMiscProductsPageHeader
            isDesktop={isDesktop}
            count={cartItems.length}
            search={search}
            setSearch={setSearch}
            orderByFavorites={orderByFavorites}
            setOrderByFavorites={setOrderByFavorites}
            openDrawer={toggleDrawer}
            openCart={handleShoppingCartToggle}
            productMutatePerm={productMutatePerm}
          />
          <FeesAndMiscProductsTable
            search={debouncedSearch}
            orderByFavorites={orderByFavorites}
            setProductId={setProductId}
            openDrawer={toggleDrawer}
            cartItems={cartItems}
            setCartItems={setCartItems}
            productMutatePerm={productMutatePerm}
            invoiceCreatePerm={invoiceCreatePerm}
          />
        </Stack>
        <ShoppingCart
          isDesktop={isDesktop}
          visible={isShoppingCartOpened || isDesktop}
          cartItems={cartItems}
          setCartItems={setCartItems}
          closeCart={handleShoppingCartToggle}
          permission={invoiceCreatePerm}
          productTypeModule='fees-and-misc'
        />
      </Flex>
      <DrawerFeesAndMiscProductsForm
        opened={isFeeAndMiscDrawerOpened}
        closeHandler={handleCloseDrawer}
        productId={productId}
        permission={productMutatePerm}
        handleResetCart={() => setCartItems([])}
      />
    </>
  );
};

export default FeesAndMiscProducts;
